export default "__VITE_ASSET__DpyLgk08__"